module.exports = __webpack_public_path__ + "img/Plus1.d63ea35c.svg";